import { AuthHelper } from '../../utils/auth_helper';
import { EmpBidListingForm } from "../../components/emp/EmpBidListingForm";

import React from "react";
import Grid from '@mui/material/Grid';


function EmpBidListing() {

  return (
    <div>
      <AuthHelper/>
      <div className="tw-px-5 sm:tw-ml-20 tw-text-left">

          
          <Grid container direction="row" alignItems="center" justifyContent="" >

            <Grid container>
              <Grid item xs={12} sm={12}>
                <span className="tw-p-10 tw-text-3xl"><p>Employee Bid Listing</p></span>
              </Grid>
            </Grid>

            <EmpBidListingForm />

          </Grid>
          
      </div>

    </div>
  );

}


export { EmpBidListing };
